import { css } from "@emotion/css";
import { themeTokens, space, text } from "@octopusdeploy/design-system-tokens";
import { NoSearchResultsIllustration } from "../../Illustrations/NoSearchResultsIllustration";
export function EmptyStateNoResults() {
    return (<div className={emptyStateNoResultsStyles.root}>
            <NoSearchResultsIllustration />
            <h2 className={emptyStateNoResultsStyles.heading}>No results found.</h2>
            <p className={emptyStateNoResultsStyles.description}>Try adjusting your filters or search term.</p>
        </div>);
}
const emptyStateNoResultsStyles = {
    root: css({
        padding: space[48],
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }),
    heading: css({
        color: themeTokens.color.text.primary,
        font: text.heading.small,
        margin: 0,
        marginTop: space[16],
    }),
    description: css({
        color: themeTokens.color.text.secondary,
        font: text.body.regular.medium,
        margin: 0,
        marginTop: space[8],
    }),
};
